import ResetPasswordPage from "./ResetPasswordPage";
import i18next from "i18next";

import fr_FR from "./i18n/fr_FR";

i18next.addResourceBundle("fr-FR", "resetPasswordApp", fr_FR);

export const ResetPasswordPageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: "onlyGuest",
  routes: [
    {
      path: "/auth/reset-password",
      component: ResetPasswordPage,
    },
  ],
};
